export default {
    // This is used to store an action datapoint with customData, so the customData parameters must match the parameters of the action it is tracking.
    FPAddDataProvider: {
        datapoint: {
            name: 'FPAddDataProvider',
            customData: function (redirectUrl, providerType, getAddableFileProviderInfoFunc) { return [providerType]; },
        },
    },
    FPAddDataProviderAuthWindowOpened: {
        datapoint: {
            name: 'FPAddDataProviderAuthWindowOpened',
            customData: function (dataProviderAdded) { return [dataProviderAdded]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map